export default __webpack_public_path__ + "static/media/regifted_socks.1e5efa24.png";